/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BankSaveResultViewModel } from "../types/BankSaveResultViewModel.ts";

export const bankSaveResultViewModelSchema = z.object({
  id: z.optional(z.number().int()),
}) as unknown as ToZod<BankSaveResultViewModel>;
